import { FC, useState } from 'react';
import DropdownAutocomplete from 'view/components/DropdownAutocomplete';
import { useGetDropdownData } from 'view/pages/profile/hooks/useGetDropdownData';
import { DropdownsEnum } from 'infrastructure/enums/DropdownsEnum';

const IndustryDropdownAutocomplete: FC<any> = ({
  setValue,
  industryValue,
  label = 'Industry *',
}) => {
  const [inputValue, setInputValue] = useState('');

  const { data: industryData, isLoading: isIndustryDataLoading } = useGetDropdownData(
    DropdownsEnum.INDUSTRY
  );

  return (
    <DropdownAutocomplete
      label={label}
      value={industryValue}
      onChange={(value: any) => {
        return setValue('industry', value);
      }}
      inputValue={inputValue}
      setInputValue={setInputValue}
      data={industryData}
      isLoading={isIndustryDataLoading}
      getOptionLabel={(option: any) => {
        return `${option.name}`;
      }}
    />
  );
};

export default IndustryDropdownAutocomplete;
